<table mat-table matSort [dataSource]="items" class="fulfilment-items-list">

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let item"> {{item.orderItem.medicineDosagePackageType.label_name}} </td>
  </ng-container>

  <ng-container matColumnDef="barcode">
    <th mat-header-cell *matHeaderCellDef>Barcode</th>
    <td mat-cell *matCellDef="let item">
      <p class="barcode">
        <mat-form-field appearance="outline">
          <mat-label>Barcode</mat-label>
          <input (focus)="focusBarcode(item)"  (blur)="onBarcodeBlur(item)" required matInput id="{{item.barcodeInputId}}"
            [formControl]="item.barcodeInput" placeholder="Barcode">
            <button color="{{ item.activated ? 'primary' : ''}}" title="Click to scan" matSuffix class="me-2"
              (click)="focusBarcode(item)" mat-icon-button>
              <mat-icon>
                {{item.focusedInput === FocusedInput.Barcode ? 'radio_button_checked':
                'radio_button_unchecked'}}
              </mat-icon>
            </button>
            @if (item.barcodeInput.invalid) {
              <mat-error>
                Barcode is not valid
              </mat-error>
            }
            <mat-hint>Examples AMI001001, BOLT02523, ABC2345-003</mat-hint>
          </mat-form-field>
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="medicine_number">
      <th mat-header-cell *matHeaderCellDef>Medicine number</th>
      <td mat-cell *matCellDef="let item">
        <p class="medicine_number">
          <mat-form-field appearance="outline">
            <mat-label>Medicine number</mat-label>
            <input (focus)="focusMedicineNumber(item)" required matInput id="{{item.medicineNumberInputId}}"
              [formControl]="item.medicineNumberInput" placeholder="Medicine number">
              <button color="{{ item.activated ? 'primary' : ''}}" title="Click to scan" matSuffix class="me-2"
                (click)="focusMedicineNumber(item)" mat-icon-button>
                <mat-icon>
                  {{item.focusedInput === FocusedInput.MedicineNumber ? 'radio_button_checked':
                  'radio_button_unchecked'}}
                </mat-icon>
              </button>
              @if (item.medicineNumberInput.invalid) {
                <mat-error>
                  Medicine number is not valid
                </mat-error>
              }
            </mat-form-field>
          </p>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let item">
          {{item.orderItem.status ? item.orderItem.status.status: "-"}}
        </td>
      </ng-container>

      <ng-container matColumnDef="scanned">
        <th mat-header-cell *matHeaderCellDef>Scanned</th>
        <td mat-cell *matCellDef="let item">
          <p>{{item.scanned + " / " + item.orderItem.quantity }}</p>
          <mat-progress-bar color="{{item.errored ? 'warn' : 'primary'}}" mode="determinate"
          [value]="percentage(item)"></mat-progress-bar>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let item">

          <button mat-flat-button color="primary" (click)="activateItem(item)">
            Scan
          </button>

        </td>
      </ng-container>

      <ng-container matColumnDef="details">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let item" class="text-end">

          <button mat-stroked-button (click)="openDetails(item.orderItem)">
            <mat-icon>info</mat-icon> Details
          </button>

        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr [class.activated]="row.activated" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>